import IconInput from '@/components/custom/icon-input'

export default function SearchBarFilter({
  searchValue,
  onSearchChange,
  type,
}: {
  searchValue?: string
  onSearchChange?: (value: string) => void
  type: 'categories' | 'transactions'
}) {
  return (
    <div className="flex-1">
      <IconInput
        placeholder={`Search ${type}...`}
        value={searchValue || ''}
        onChange={(e) => onSearchChange?.(e.target.value)}
        className="w-full"
      />
    </div>
  )
}
